window.PosterGenerator = class PosterGenerator {
  _frame = null;
  _container = null;
  elements = [];

  constructor(options = {}) {
    const width = options.width || "210mm";
    const height = options.height || "297mm";
    this._frame = document.createElement("iframe");
    this._frame.style.width = "100%";
    this._frame.style.border = "none";
    this._frame.style.aspectRatio = options.aspectRatio || "210/297";
    this._frame.style.overflow = "hidden";
    this._frame.scrolling = "no";
    this._frame.srcdoc = `<html>
      <head>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js" async></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js" async></script>
        <script>
          function updatePageScale() {
            try {
              const wrapper = document.querySelector("#wrapper");
              const container = document.querySelector("#container");
              let pageScale = Math.max(0, Math.min(1, Math.max((wrapper.clientWidth || 1) / container.clientWidth, (wrapper.clientHeight || 1) / container.clientHeight)));
              document.querySelector("#page").style.transform = "scale(" + pageScale + ")";
            } finally {
              setTimeout(() => document.body.style.opacity = 1, 1000);
            }
          }
          document.addEventListener("DOMContentLoaded", updatePageScale);
          window.addEventListener("resize", updatePageScale);
        </script>
        <style>
          ${options.css || ""}
        </style>
      </head>
      <body style="padding: 0; margin: 0; transition: opacity 1s; opacity: 0;">
        <div id="wrapper" style="aspect-ratio: ${options.aspectRatio || "210/297"}; max-width: 100%; overflow: hidden; margin: auto">
          <div id="page" style="background: white; transform-origin: top left;">
            <div id="container" style="height: ${height}; width: ${width}; position: relative; margin: auto;">
              ${options.htmlTemplate || ""}
            </div>
          </div>
        </div>
      </body>
    </html>`;

    this._frame.onload = () => {
      this._container = this._frame.contentDocument.getElementById("container");
      if (options.elements) {
        for (const [index, element] of options.elements.entries()) {
          const el = new _PosterElement(this._frame, index, element);
          this._container.append(el.node);
          this.elements.push(el);
          if (element.id) this.elements[element.id] = el;
        }
      }
    };
    let parent = document.body;
    if (options.previewContainer) {
      parent = document.querySelector(options.previewContainer);
    } else {
      this._frame.style.display = "none";
    }
    parent.append(this._frame);
  }
  
  async download(options = {}) {
    const format = options.format || "pdf";
    const filename = (`${(options.filename || "affiche").trim()}.${format}`).replace(`.${format}.${format}`, `.${format}`);
    try {
      var generator = this._frame.contentWindow
        .html2pdf()
        .set({
          filename,
          margin:
            options && options.margin
              ? typeof options.margin === "number"
                ? options.margin
                : this._frame.contentWindow.Array.from(options.margin)
              : 0,
          image: {
            type: options.image_type || (format === "png" ? "png" : "jpeg"),
            quality: options.jpeg_quality || 0.9,
          },
          html2canvas: {
            dpi: options.dpi,
            scale:
              options.scale || Math.ceil(3000 / Math.max(this._container.clientHeight, this._container.clientWidth)),
            scrollX: 0,
            scrollY: 0,
            allowTaint: true,
            width: this._container.clientWidth,
            height: this._container.clientHeight,
            imageTimeout: 0,
          },
          jsPDF: {
            unit: "mm",
            format: options.page_format || "a4",
            orientation: options.orientation || "portrait",
          },
        })
        .from(this._container);
      if (format === "pdf") {
        await generator.save();
      } else {
        const dataurl = await generator.outputImg("dataurlstring");
        var link = document.createElement("a");
        link.download = filename;
        link.href = dataurl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log("error", error);
    }
  }
};

class _PosterElement {
  type;
  data;
  _frame;
  node;
  constructor(frame, index, elOptions) {
    this.type = elOptions.type;
    this._frame = frame;
    const _doc = frame.contentDocument;
    // create node
    if (this.type === "font") {
      this.node = _doc.createElement("link");
      this.node.rel = "stylesheet";
    } else if (this.type === "image") {
      this.node = _doc.createElement("div");
      const img = _doc.createElement("img");
      img.style.minWidth = "100%";
      img.style.minHeight = "100%";
      img.style.position = "absolute";
      img.style.top = "50%";
      img.style.left = "50%";
      img.style.transform = "translate(-50%, -50%)";
      img.onload = () => {
        let heightRatio = img.clientHeight / this.node.clientHeight;
        let widthRatio = img.clientWidth / this.node.clientWidth;
        if (heightRatio > 1 && widthRatio > 1) {
          if (heightRatio > widthRatio) {
            img.style.width = "100%";
          } else {
            img.style.height = "100%";
          }
        }
      };
      this.node.append(img);
      this.setStyles({
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: index * 5,
        overflow: "hidden",
      });
    } else {
      this.node = _doc.createElement("div");
      this.setStyles({
        position: "absolute",
        zIndex: index * 5,
      });
    }
    if (elOptions.id) this.node.id = elOptions.id;
    // bind input fields
    if (elOptions.field_selector) {
      if (this.type === "image") {
        document.querySelector(elOptions.field_selector).addEventListener("change", (event) => {
          if (!event.target.files) {
            this.setData(event.target.value);
          } else if (event.target.files.length) {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(event.target.files[0]);
            fileReader.addEventListener("load", (evt) => this.setData(evt.target.result));
          }
        });
      } else {
        document.querySelector(elOptions.field_selector).addEventListener("input", (e) => {
          this.setData(e.target.value);
        });
      }
    }
    this.setStyles(elOptions.styles);
    this.setData(elOptions.data);
  }
  setData(data) {
    this.data = data;
    if (this.type === "image") {
      this.node.children[0].style.width = null;
      this.node.children[0].style.height = null;
      if (this.data) {
        this.node.children[0].src = this.data;
      } else {
        this.node.children[0].removeAttribute("src");
      }
    } else if (this.type === "text") {
      this.node.innerText = this.data;
    } else if (this.type === "qr") {
      this.node.replaceChildren(); //
      if (this.data) {
        new this._frame.contentWindow.QRCode(this.node, {
          text: this.data.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
          width: this.node.clientWidth || parseInt(this.node.style.width) || 100,
          height: this.node.clientHeight || parseInt(this.node.style.height) || 100,
          colorDark: this.node.style.color || "#000000",
          colorLight: this.node.style.backgroundColor || "hsla(0, 0%, 0%, 0)",
          correctLevel: this._frame.contentWindow.QRCode.CorrectLevel.H,
        });
      }
    } else if (this.type == "font") {
      this.node.href = this.data;
    }
  }
  setStyles(styles) {
    if (!styles) return;
    if (typeof styles === "string") {
      this.node.setAttribute("style", this.node.getAttribute("style") + "; " + styles);
    } else {
      for (const [key, value] of Object.entries(styles)) {
        this.node.style[key] = value;
      }
    }
  }
}
